import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 17h2","key":"svg-0"}],["path",{"d":"M20 17h2","key":"svg-1"}],["path",{"d":"M4 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-2"}],["path",{"d":"M16 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-3"}],["path",{"d":"M6 11h12","key":"svg-4"}],["path",{"d":"M12 11v-6","key":"svg-5"}]]

const IconCircuitPushbutton = createReactComponent('outline', 'circuit-pushbutton', 'CircuitPushbutton', __iconNode);

export default IconCircuitPushbutton;